import * as types from './constants';

export const setProduct = data => ({
  type: types.SET_PRODUCT,
  data
});

export const setProductSellId = id => ({
  type: types.SET_PRODUCT_ID,
  id
});

export const setProductSellUuid = uuid => ({
  type: types.SET_PRODUCT_UUID,
  uuid
});

export const setSupplier = data => ({
  type: types.SET_SUPPLIER,
  data
});

export const setSuppliers = data => ({
  type: types.SET_SUPPLIERS,
  data
});

export const setSupplierErrors = errors => ({
  type: types.SET_SUPPLIER_ERRORS,
  errors
});

export const clearSupplierErrors = () => ({
  type: types.CLEAR_SUPPLIER_ERRORS
});

export const setSupplierUuid = uuid => ({
  type: types.SET_SUPPLIER_UUID,
  uuid
});

export const setProductBasic = data => ({
  type: types.SET_PRODUCT_BASIC,
  data
});

export const setProductStorage = data => ({
  type: types.SET_PRODUCT_STORAGE,
  data
});

export const setProductIdentifiers = data => ({
  type: types.SET_PRODUCT_IDENTIFIERS,
  data
});

export const setProductProvisionalReceipt = data => ({
  type: types.SET_PRODUCT_PROVISIONAL_RECEIPT,
  data
});

export const clearProductProvisionalReceipt = () => ({
  type: types.CLEAR_PRODUCT_PROVISIONAL_RECEIPT
});

export const setProductBasicAndStorageResponse = data => ({
  type: types.SET_PRODUCT_BASIC_AND_STORAGE_RESPONSE,
  data
});

export const setProductBasicAndStorageResponseErrors = data => ({
  type: types.SET_PRODUCT_BASIC_AND_STORAGE_RESPONSE_ERRORS,
  data
});

export const clearProductBasicAndStorageResponseErrors = () => ({
  type: types.CLEAR_PRODUCT_BASIC_AND_STORAGE_RESPONSE_ERRORS
});

export const setProductLoading = isLoading => ({
  type: types.SET_PRODUCT_LOADING,
  isLoading
});

export const setSupplierLoading = isLoading => ({
  type: types.SET_SUPPLIER_LOADING,
  isLoading
});

export const clearProductSell = () => ({
  type: types.CLEAR_PRODUCT
});

export const clearSupplier = () => ({
  type: types.CLEAR_SUPPLIER
});